var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { observable } from "mobx";
import { SimpleDialogModel } from "./SimpleDialogModel";
export class DesignSystemDemoViewModel {
    constructor() {
        this.autocompleteSingleValue = null;
        this.autocompleteMultiValue = [];
        this.simpleDialogModel = new SimpleDialogModel();
        this.paginationCurrentPage = 3;
        this.toggleSwitchValue = false;
        this.textFieldValue = "";
    }
    setAutocompleteSingleValue(autocompleteSingleValue) {
        this.autocompleteSingleValue = autocompleteSingleValue;
    }
    setAutocompleteMultiValue(autocompleteMultiValue) {
        this.autocompleteMultiValue = autocompleteMultiValue;
    }
    setPaginationCurrentPage(paginationCurrentPage) {
        this.paginationCurrentPage = paginationCurrentPage;
    }
    setToggleSwitchValue(toggleSwitchValue) {
        this.toggleSwitchValue = toggleSwitchValue;
    }
    setTextFieldValue(textFieldValue) {
        this.textFieldValue = textFieldValue;
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], DesignSystemDemoViewModel.prototype, "autocompleteSingleValue", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], DesignSystemDemoViewModel.prototype, "autocompleteMultiValue", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DesignSystemDemoViewModel.prototype, "paginationCurrentPage", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DesignSystemDemoViewModel.prototype, "toggleSwitchValue", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], DesignSystemDemoViewModel.prototype, "textFieldValue", void 0);
